import Entity from "../../../class/abstract/Entity";
import License from "../../_account/Licenses/License";
import ManualDrawer from "./ManualDrawer";

class ManualDrawerLicense extends Entity {
    manual_drawer_id = null;
    manualDrawer = {};
    license_id = null;
    license = {};

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
                if(key === "manualDrawer")
                    Reflect.set(this, key, new ManualDrawer(datas[key]));
                else if(key === "license")
                    Reflect.set(this, key, new License(datas[key]));
                else
                    Reflect.set(this, key, datas[key]);
            }
        }
    }
}

export default ManualDrawerLicense;
